import e from "@dialpad/dialtone-tokens/layered/themes/tokens-cayenne-colors.css?inline";
//#region themes/cayenne.js
var t = {
	brand: {
		css: e,
		name: "cayenne"
	},
	material: { name: "graphite" }
};
//#endregion
export { t as default };
